import * as Styled from "./Button.style";
import ReactMarkdown from "react-markdown";

const Tooltip = ({ entries }) => {
  return (
    <Styled.Tooltip>
      {typeof entries === "string" && (
        <Styled.TooltipEntry>
          <ReactMarkdown>{entries}</ReactMarkdown>
        </Styled.TooltipEntry>
      )}

      {typeof entries === "object" &&
        entries.map(([left, right], i) => (
          <Styled.TooltipEntry key={i}>
            <span>{left}</span>
            <span>{right}</span>
          </Styled.TooltipEntry>
        ))}
    </Styled.Tooltip>
  );
};

export default Tooltip;
